module.exports = __webpack_public_path__ + "static/media/angle-right.0db51260.svg";